import React, { createRef } from 'react';
import {
  PDF_VIEWER_MESSAGE_TYPES,
  isPdfViewerReadyMessage
} from '@codametrix/ui-common';
import './styles/index.scss';

type PDFFrameProps = {
  pdfContent: CMxAPI.HtmlDoc;
};

const base64toBlob = (data: string) => {
  const bytes = window.atob(data);
  let length = bytes.length;
  let out = new Uint8Array(length);

  while (length--) {
    out[length] = bytes.charCodeAt(length);
  }

  return new Blob([out], { type: 'application/pdf' });
};

class PDFFrame extends React.Component<PDFFrameProps> {
  _iframeRef: React.RefObject<HTMLIFrameElement | null>;
  _isViewerReady = false;
  _objectUrl: string | null = null;

  constructor(props: PDFFrameProps) {
    super(props);
    this._iframeRef = createRef();
    this.handleMessage = this.handleMessage.bind(this);
  }

  componentDidMount() {
    window.addEventListener('message', this.handleMessage);
  }

  componentDidUpdate(prevProps: PDFFrameProps) {
    if (
      this._isViewerReady &&
      this.props.pdfContent.id !== prevProps.pdfContent.id
    ) {
      this.sendPdfContent();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleMessage);
    this.revokeObjectUrl();
  }

  handleMessage(event: MessageEvent) {
    if (event.origin !== window.location.origin) {
      return;
    }

    const iframeWindow = this._iframeRef.current?.contentWindow;
    if (!iframeWindow || event.source !== iframeWindow) {
      return;
    }

    if (!isPdfViewerReadyMessage(event.data)) {
      return;
    }

    this._isViewerReady = true;
    this.sendPdfContent();
  }

  revokeObjectUrl() {
    if (this._objectUrl) {
      URL.revokeObjectURL(this._objectUrl);
      this._objectUrl = null;
    }
  }

  sendPdfContent() {
    const { pdfContent: iframeNote } = this.props;
    const iframeWindow = this._iframeRef.current?.contentWindow;

    if (!iframeNote.content || !iframeWindow) {
      return;
    }

    this.revokeObjectUrl();

    const blob = base64toBlob(iframeNote.content);
    const pdfContent = URL.createObjectURL(blob);
    this._objectUrl = pdfContent;

    iframeWindow.postMessage(
      {
        type: PDF_VIEWER_MESSAGE_TYPES.PDF_VIEWER_CONTENT,
        pdfContent
      },
      window.location.origin
    );
  }

  render() {
    return (
      <iframe
        className="note-iframe"
        src="/app/pdf-viewer/"
        height="800px"
        min-width="450px"
        ref={this._iframeRef}
        title="PDF Viewer"
      />
    );
  }
}

export { PDFFrame };
